const API_URL = process.env.REACT_APP_API_URL;

const fetchData = (url, { isStatic = false, cache } = {}) => {
  const myHeaders = new Headers();
  myHeaders.append('Accept', 'application/json');

  const requestOptions = {
    method: 'GET',
    headers: myHeaders
    // cache: cache
  };

  if (cache) {
    requestOptions.cache = cache;
  }

  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async res => {
    /*Pauses the execution of the program for the specified number of milliseconds.*/
    // const userDataJson = window.localStorage.getItem('kerpUserData2.1');
    // const parsedUserData = JSON.parse(userDataJson || '{}');

    /*A promise that resolves with the fetched data if the response status is true,
     * or rejects with an error message if there was an error or the response status is false.*/
    fetch(isStatic ? url : `${API_URL}/${url}`, requestOptions)
      .then(response => {
        return response.json();
      })
      .then(response => {
        if (
          response.status === true ||
          response.Code === true ||
          response.status === 'Success'
        ) {
          return res({
            status: true,
            data: response.data || response.Data,
            code: response.code
          });
        } else {
          return res({
            status: false,
            message: response.Message,
            data: response.data,
            code: response.code
          });
        }
      })
      .catch(err => {
        return res({ message: err.message, status: false });
      });
  });
};

export default fetchData;
